module.exports = __webpack_public_path__ + "static/media/26_plantilla_navidad_menu_4_rec_fondo_motivo_1.cf38f03e.png";